import { DateFilters } from '@store/redux/features/filter/filterSlice';

export function disableConfirmDate(
  localDateFilter: DateFilters,
  filter: Partial<DateFilters>,
): boolean | undefined {
  // dates defined
  const notDefined = !localDateFilter.endDate && !localDateFilter.startDate;
  const eq =
    filter.endDate === localDateFilter.endDate &&
    filter.startDate === localDateFilter.startDate; // both null
  return notDefined && eq;
}
